import { useAlbumContext } from '@/contexts/AlbumProvider';

export const useAlbumNavigation = () => {
  const { albumSlug, loading } = useAlbumContext();

  const getAlbumPath = (path: string) => {
    // If we're still loading, don't return a path yet
    if (loading) return null;
    if (!albumSlug) return '/';
    return `/${albumSlug}${path}`;
  };

  return { getAlbumPath, albumSlug, loading };
};